<template lang="pug">
  div.safe-img-container(:class="className")
    template(v-if="!isError && src")
      img.safe-img(
        :src="src"
        :alt="alt"
        @error="handleImgError"
      )
    template(v-else)
      img.safe-default-img(
        v-if="defaultImg"
        :src="defaultImg"
        :alt="alt"
      )
      .safe-default-bg(v-else)
</template>

<script>
export default {
  name: 'SafeImg',
  props: {
    // 自定义类名
    className: {
      type: String,
      default: '',
    },
    // 图片地址
    src: {
      type: String,
      default: '',
    },
    // 兜底图片地址
    defaultImg: {
      type: String,
      default: '',
    },
    // 图片描述
    alt: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isError: false,
    };
  },
  mounted() {},
  methods: {
    // 图片加载失败
    handleImgError() {
      this.isError = true;
    },
  },
};
</script>

<style lang="less" scoped>
.safe-img-container {
  width: 100%;
  height: 100%;

  .safe-img,
  .safe-default-img {
    width: 100%;
    height: 100%;
    vertical-align: bottom;
  }

  .safe-default-bg {
    width: 100%;
    height: 100%;
    background-color: #f0f3f5;
  }
}
</style>
